import React from 'react';
import {
  Grid
  , Paper
  , FormHelperText
  , FormControl
  , GridSize
  , Tooltip
  , Zoom
  , Card
  , CardContent
  , CardHeader
  , Divider
  , Typography
  , Button,
  CardActions
} from '@material-ui/core';

import ErrorIcon from '@material-ui/icons/Error';

import { connect, useDispatch, useSelector } from 'react-redux';
import { change, getFormValues } from 'redux-form';

import helpSvg from '../assets/img/help.svg';
// import noimage from '../assets/img/noimage.png';

import { handleFieldChange } from '../helpers/renderHelper';
// import Carousel from 'react-material-ui-carousel';
// import PeImage from './PeImage';
import State from '../states/State';
import slice from '../states/shell/slice';
import useStyles from '../styles/styles';
import { formName } from '../thunks/constants';
import dialogSlice from '../states/dialog/slice';

import { HiOutlineViewList } from 'react-icons/hi';
import { GiBrickWall } from 'react-icons/gi';
import { AiOutlineAppstoreAdd, AiOutlineBlock } from 'react-icons/ai';

type PeOptionProps = {
  readonly item: any,
  readonly name: string,
  readonly sm?: GridSize,
  readonly xs?: GridSize,
  readonly formValues: any,
};

const trimString = (source: string) => {
  if (source.length < 130) return source;
  return source.substring(0, 130).concat('...');
}

type PeCardProps = {
  readonly item: any,
  readonly onClickHandle?: any,
  readonly onClickDialog?: any,
  readonly active?: boolean,
}
const PeCardOption: React.FC<PeCardProps> = props => {
  const classes = useStyles();

  return <Card variant="outlined" style={{cursor: 'pointer'}}>
    <CardHeader
      style={props.active ? { background: '#F49029', color: 'white' } : {}}
      title={
        <Typography gutterBottom 
          variant="h5" 
          component="h3" 
          className={classes.sandenName} 
          style={{textAlign: 'center'}}
        >
          {props.item.label}
        </Typography>
      }
    />
    <Divider />
    <CardContent>
      <Tooltip title={props.item.message}>
        <p style={{ margin: 0, textAlign: 'center' }}>{trimString(props.item.message)}</p>
      </Tooltip>
    </CardContent>
    <CardActions style={{ marginBottom: 10, justifyContent: 'space-evenly', padding: '0px'}}>
      <Button size="small" variant="outlined" style={{ display: props.item.image ? 'block' : 'none'}} onClick={props.onClickDialog}>Learn more</Button>
      <Button size="small" variant="outlined" style={{ margin: '0px' }} color="primary" onClick={props.onClickHandle}>Select</Button>
    </CardActions>
  </Card>
}

const PeOption: React.FC<PeOptionProps> = props => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const state = useSelector((state: State) => ({
    templates: state.shell.templates,
    shell: state.shell,
  }));

  const { sms, signature } = state.templates;

  let active = typeof props.formValues !== 'undefined' && props.formValues[props.name] === props.item.value;
  let smNumber: GridSize = props.item.sm ? props.item.sm : props.sm ? props.sm : 3;

  const onClickDialog = () => {
    dispatch(dialogSlice.actions.updateDialogContent({ message: props.item.message, title: props.item.label, image: props.item.image }));
    dispatch(dialogSlice.actions.updateDialog(true));
  }

  const onClickHandle = () => {
    // set scroll target
    dispatch(slice.actions.updateScrollTarget(props.name));

    // set current value to field
    dispatch(change(formName, props.name, props.item.value));
    // handleFieldChange
    handleFieldChange(props.name, dispatch, formName, props.item.value);

    // special case
    switch (props.name) {
      case "prepared_by":
        // set value to text area
        dispatch(change(formName, "sms_template", getSignatureByPrepare(props.item.value)));
        break;
      case "send_sms":
        // set value to text area
        dispatch(change(formName, "sms_template", getSignatureByPrepare(props.formValues.prepared_by)));
        break;
      default: break;
    }
  }
  // console.log(props.name);

  const getSignatureByPrepare = (value?: string) => {
    // Get client first name
    let firstName = props.formValues.first_name;
    let content = sms.replaceAll("$first_name", firstName);
    // let signatureStr = "Regard - Pure Electric Admin";
    let signatureStr = "Regards, Pure Electric - info@pure-electric.com.au / 1300 86 78 73";
    if (value) {
      for (var key in signature) {
        if (signature.hasOwnProperty(key)) {
          if (signature[key]["first_name"] === value.split(' ')[0]) {
            signatureStr = signature[key]['sms_signature'];
          }
        }
      }
    }

    return content.concat("\n").concat(signatureStr);
  }

  const renderImg = (img: string) => {
    switch (img) {
      case 'veneer':
        return <GiBrickWall fontSize="40" />
      case 'double':
        return <AiOutlineBlock fontSize="40" />
      case 'other':
        return <AiOutlineAppstoreAdd fontSize="40" />
      case 'weather':
        return <HiOutlineViewList fontSize="40" />
      default: break;
    }
  }

  return <Grid key={props.item.value} item sm={smNumber} xs={props.xs ? props.xs : 6}>
    {props.item.message 
      ? <PeCardOption {...props} onClickHandle={onClickHandle} onClickDialog={onClickDialog} active={active}/>
      : <Paper className={`${active ? classes.PeSingleChoice_paper + ' ' + classes.active : classes.PeSingleChoice_paper} ${props.item.img && classes.optionIcon}`} onClick={onClickHandle}>
        {props.item.img && <div className={classes.optImg}>{renderImg(props.item.img)}</div>}
        <div className={classes.optDetail}>
          <p className={classes.optDetail + 'Label'}>{props.item.label}</p>
          {props.item.subLabel && <span className={classes.optDetail + 'SubLabel'}>{props.item.subLabel}</span>}
        </div>
      </Paper>
    }
  </Grid>
}

const PeOptionConnect = connect(state => ({
  formValues: getFormValues(formName)(state),
}))(PeOption);

type PeSingleChoiceProps = {
  readonly input?: any,
  readonly id: string,
  readonly label: string,
  readonly initValue?: string,
  readonly required?: boolean,
  readonly options: any,
  readonly images?: any,
  readonly condition?: any,
  readonly toolTip?: string,
  readonly sm?: GridSize,
  readonly xs?: GridSize,
  readonly meta: {
    touched: any,
    error: any,
    form: any,
  },
  readonly formValues: any,
  readonly source: string,
};

const PeSingleChoice: React.FC<PeSingleChoiceProps> = ({ id, images, meta, input, required, label, toolTip, options, sm, xs, formValues, source }) => {
  const classes = useStyles();
  const state = useSelector((state: State) => ({
    templates: state.shell.templates,
    shell: state.shell,
  }));
  const isLayout = state.shell.layout;

  const getOption = () => {
    if (source) {
      // get option from source
      switch (source) {
        case 'pricingOptions':
          return state.shell.productData.pricingOptions;
        default:
          return options;
      }
    } else {
      return options;
    }
  }

  const mainOption = getOption();

  const [currentChoice, setCurrentChoice] = React.useState(formValues && formValues[input.name] ? formValues[input.name] : undefined);
  const [currentImage, setCurrentImage] = React.useState(undefined);

  React.useEffect(() => {
    setCurrentChoice(formValues && formValues[input.name] ? formValues[input.name] : undefined);
    // eslint-disable-next-line
  }, [formValues]);

  React.useEffect(() => {
    if (currentChoice && images) {
      let selectedOpt = mainOption.filter((item: any) => item.value === currentChoice)[0];
      setCurrentImage(selectedOpt ? selectedOpt.image : mainOption.at(-1).image);
    } else {
      setCurrentImage(mainOption.at(-1).image);
    }
    // eslint-disable-next-line
  }, [currentChoice]);

  return <div id={id} className={images ? classes.controlImg : classes.control}>
    <FormControl error={Boolean(meta?.error)} variant="outlined" fullWidth>
      <input type="hidden" {...input}></input>
      <div className={classes.labelArea}>
        <h3 className={classes.label}>
          {required && <span className={classes.required}>*</span>}&nbsp;{label}
        </h3>
        {isLayout !== 2 && toolTip && <Tooltip title={toolTip} TransitionComponent={Zoom} placement="right-end" arrow>
          <img src={helpSvg} alt="help" className={classes.iconHelp} />
        </Tooltip>}
      </div>

      {images ? <Grid container spacing={3} style={{ alignItems: 'flex-start' }}>
        <Grid container item sm={6} spacing={3}>
          {mainOption.map((item: any) => {
            return <PeOptionConnect key={item.value} item={item} name={input.name} sm={6} xs={xs}/>
          })}
        </Grid>
        <Grid container item sm={6}>
          <Grid  item xs={12} sm={12}>
            {/* <PeImage src={currentImage} alt={"alt"} placeHolder={noimage} keepRatio classes /> */}
            <img src={currentImage} alt={"alt"} style={{width: '100%'}}/>
          </Grid>
        </Grid>
      </Grid> : <Grid item container spacing={3}>
        {mainOption.map((item: any) => {
          return <PeOptionConnect key={item.value} item={item} name={input.name} sm={isLayout === 2 ? 6 : sm} xs={xs}/>
        })}
      </Grid>}

      {meta?.error && <FormHelperText className={classes.helpText} component="div">
        <ErrorIcon fontSize="small" />
        <p style={{ margin: 0, padding: 0 }}>&nbsp;{meta?.error}</p>
      </FormHelperText>}
    </FormControl>
  </div>
}

export default connect(state => ({
  formValues: getFormValues(formName)(state),
}))(PeSingleChoice);